import { render, staticRenderFns } from "./ReviewsCategoriesChartWrapper.vue?vue&type=template&id=450efa60&scoped=true&"
import script from "./ReviewsCategoriesChartWrapper.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesChartWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesChartWrapper.vue?vue&type=style&index=0&id=450efa60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450efa60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VProgressCircular})
